import Blue from "~/core";

new Blue({
	name: 'Header Nav Menu',
  selector: ".header",
  setup(header) {
		const navItems = [...header.querySelectorAll(".header__main-item--parent")];
		const minScreenWidth = 991;
		const drawer = header.querySelector(".header__drawer");
		const utilNav = header.querySelector("nav.header__util-nav");
		const mainNav = header.querySelector("nav.header__main-nav");
		const mobileTrigger = header.querySelector(".header__mobile-trigger");
		const secondaryLinks = [...header.querySelectorAll(".header__secondary-link")];

		secondaryLinks.forEach(link => {
			link.setAttribute("tabindex", "0");
		});

		navItems.forEach(item => {
			const link = item.querySelector(".header__main-link");
			let btn = document.createElement("button");
			const icon = document.createElement("i");
			btn.classList.add("header__accordion-trigger");
			icon.classList.add("blue-icon-arrow_down");
			link.insertAdjacentElement('afterend', btn);
			btn.insertAdjacentElement('beforeend', icon);
		});

		// DESKTOP NAV TRIGGER
		navItems.forEach(item => {
			const list = item.querySelector(".header__secondary-list");
			this.$addEvents(item, 'mouseover space.prevent', () => {
				if (window.innerWidth >= minScreenWidth) {
					list.classList.add("nav-open");
				}
			});
			this.$addEvents(item, 'mouseleave focusout', () => {
				if (!item.matches(":focus-within")) {
					list.classList.remove("nav-open");
				}
			});
		});

		// MOBILE RETACH TO DRAWER
		this.$retach(mainNav, {
			destination: drawer,
			mediaQuery: minScreenWidth,
			moveMethod: 'append'
		});
		this.$retach(utilNav, {
			destination: drawer,
			mediaQuery: minScreenWidth,
			moveMethod: 'append'
		});

		// MOBILE NAV TRIGGER
		const closeAllAccordions = () => {
			let openAccordions = [...drawer.querySelectorAll("[data-active]")];
			openAccordions.forEach(acc => {
				acc.removeAttribute("data-active");
			})
		}

		this.$addEvents(mobileTrigger, 'click', () => {
			mobileTrigger.classList.toggle("active");
			drawer.classList.toggle("is-open");
			header.classList.toggle("modal-open");
			if (header.matches(".modal-open")) {
				document.querySelector(".content").style.filter = "blur(4px)";
			} else {
				document.querySelector(".content").style.filter = "";
			}
			if (!drawer.matches(".is-open")) {
				closeAllAccordions();
			}
		});

		this.$addEvents(document.body, 'click', (e) => {
			if (!e.target.closest(".header__inner") && !e.target.closest(".header__drawer")) {
				mobileTrigger.classList.remove("active");
				drawer.classList.remove("is-open");
				header.classList.remove("modal-open");
				document.querySelector(".content").style.filter = "";
				closeAllAccordions();
			}
		});

		let relations = [];

		const initAccordion = () => {
			navItems.forEach(container => {
				let trigger = container.querySelector('button.header__accordion-trigger');
				let content = container.querySelector('.header__secondary-list');
				let config = {
					container,
					trigger,
					content,
					relations
				}
				relations.push(new this.$toggle(config));
			})
		}
		
		if (window.innerWidth < minScreenWidth) {
			initAccordion();
		}

		this.$addEvents(window, "resize", () => {
			if (window.innerWidth < minScreenWidth && relations.length === 0) {
				initAccordion();
			}
		});
	
  }
});
